import React from "react";
import { fmtMinutes, prettifyStoreName, fmtKr, tidsstyrtVerdi } from "./workshopCapacityUtils";

export default function WorkshopDagDetaljerModal({ open, onClose, title, services, showButikk }) {
  if (!open) return null;

  const totals = services.reduce(
    (acc, svc) => {
      const arbeidskost = Number(svc.omsetning || 0);
      const tidsstyrt = tidsstyrtVerdi(svc.tidsstyrtMin || 0);
      acc.bruktMin += Number(svc.bruktMin || 0);
      acc.arbeidskost += arbeidskost;
      acc.tidsstyrt += tidsstyrt;
      acc.totalt += arbeidskost + tidsstyrt;
      return acc;
    },
    { bruktMin: 0, arbeidskost: 0, tidsstyrt: 0, totalt: 0 }
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-5xl rounded-lg bg-white shadow-xl max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between border-b px-5 py-4 bg-gray-50">
          <div>
            <h3 className="text-lg font-semibold">{title}</h3>
            <div className="text-sm text-gray-500">{services.length} service(r)</div>
          </div>
          <button onClick={onClose} className="rounded border px-3 py-1.5 text-sm hover:bg-gray-100">
            Lukk
          </button>
        </div>

        <div className="overflow-auto max-h-[75vh] p-4">
          {services.length ? (
            <table className="min-w-full text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-3 py-2 text-left">Ref</th>
                  <th className="px-3 py-2 text-left">Kunde</th>
                  {showButikk && <th className="px-3 py-2 text-left">Butikk</th>}
                  <th className="px-3 py-2 text-left">Servicelinjer</th>
                  <th className="px-3 py-2 text-right">Tid</th>
                  <th className="px-3 py-2 text-right">Arbeidskost</th>
                  <th className="px-3 py-2 text-right">Tidsstyrt</th>
                  <th className="px-3 py-2 text-right">Totalt</th>
                </tr>
              </thead>
              <tbody>
                {services.map((svc) => {
                  const arbeidskost = Number(svc.omsetning || 0);
                  const tidsstyrt = tidsstyrtVerdi(svc.tidsstyrtMin || 0);
                  return (
                    <tr key={svc.id} className="border-t align-top">
                      <td className="px-3 py-2 font-mono text-xs text-gray-600 whitespace-nowrap">{svc.serviceRef}</td>
                      <td className="px-3 py-2 whitespace-nowrap">{svc.customerName}</td>
                      {showButikk && (
                        <td className="px-3 py-2 whitespace-nowrap text-gray-600">
                          {prettifyStoreName(svc.butikk)}
                        </td>
                      )}
                      <td className="px-3 py-2">
                        {(svc.serviceLines || []).map((l, i) => {
                          const linjeTidsstyrt = l.reklamasjon || l.gratisarbeid || l.isEtterjustering;
                          const tidsstyrtLabel = l.reklamasjon
                            ? "Reklamasjon"
                            : l.gratisarbeid
                            ? "Gratisarbeid"
                            : "Etterjustering";
                          return (
                            <div key={i} className="text-xs text-gray-700">
                              {l.navn} — {fmtMinutes(l.tidsbruk)}
                              {linjeTidsstyrt ? (
                                <span className="ml-2 text-orange-600">
                                  {tidsstyrtLabel} · {fmtKr(tidsstyrtVerdi(l.tidsbruk))}
                                </span>
                              ) : l.pris > 0 ? (
                                <span className="ml-2 text-gray-500">({l.pris.toLocaleString("nb-NO")} kr)</span>
                              ) : null}
                            </div>
                          );
                        })}
                      </td>
                      <td className="px-3 py-2 text-right whitespace-nowrap">{fmtMinutes(svc.bruktMin)}</td>
                      <td className="px-3 py-2 text-right whitespace-nowrap">{fmtKr(arbeidskost)}</td>
                      <td className="px-3 py-2 text-right whitespace-nowrap text-orange-700">
                        {tidsstyrt > 0 ? fmtKr(tidsstyrt) : "—"}
                      </td>
                      <td className="px-3 py-2 text-right font-medium whitespace-nowrap">
                        {fmtKr(arbeidskost + tidsstyrt)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="border-t bg-gray-50 font-semibold">
                <tr>
                  <td colSpan={showButikk ? 4 : 3} className="px-3 py-2 text-sm text-right">
                    Total
                  </td>
                  <td className="px-3 py-2 text-right">{fmtMinutes(totals.bruktMin)}</td>
                  <td className="px-3 py-2 text-right">{fmtKr(totals.arbeidskost)}</td>
                  <td className="px-3 py-2 text-right text-orange-700">
                    {totals.tidsstyrt > 0 ? fmtKr(totals.tidsstyrt) : "—"}
                  </td>
                  <td className="px-3 py-2 text-right">{fmtKr(totals.totalt)}</td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <div className="py-10 text-center text-gray-500">Ingen servicer funnet</div>
          )}
        </div>
      </div>
    </div>
  );
}
